import React, { useEffect, useState } from 'react'

import { FiltersDropdownNew } from '../UI/FiltersDropdownNew/FiltersDropdownNew'
import styles from './InvestmentFilter.module.scss'
import {
  InvestmentFilterConfigType,
  InvestmentFilterDropdownPropsType,
  RegionOption,
} from './InvestmentFilter.types'

export const cityFilterName = 'selected-city'

export const dropdownData: InvestmentFilterConfigType = {
  city: [
    {
      value: 'moscow',
      label: 'Москва',
    },
    {
      value: 'spb',
      label: 'Санкт-Петербург',
    },
  ],
  region: {
    moscow: [
      {
        value: '',
        label: 'Все',
      },
      {
        value: 'ВАО',
        label: 'ВАО',
      },
      {
        value: 'ЗАО',
        label: 'ЗАО',
      },
      {
        value: 'НАО',
        label: 'НАО',
      },
      {
        value: 'САО',
        label: 'САО',
      },
      {
        value: 'СВАО',
        label: 'СВАО',
      },
      {
        value: 'СЗАО',
        label: 'СЗАО',
      },
      {
        value: 'ЮАО',
        label: 'ЮАО',
      },
      {
        value: 'ЮВАО',
        label: 'ЮВАО',
      },
      {
        value: 'ЮЗАО',
        label: 'ЮЗАО',
      },
    ],
    spb: [
      {
        value: 'Санкт-Петербург',
        label: 'Все',
      },
    ],
  },
}

function InvestmentFilterDropdown(props: InvestmentFilterDropdownPropsType) {
  const { filterHandler, currentValues } = props
  const [currentCity, setcurrentCity] = useState<string>('moscow')
  const [selectedCity, setSelectedCity] = useState<RegionOption>(
    currentValues.city
  )
  const [selectedRegion, setSelectedRegion] = useState<RegionOption>(
    currentValues.region
  )

  useEffect(() => {
    filterHandler(dropdownData.region[currentCity][0].value, 'region')
  }, [currentCity])

  useEffect(() => {
    filterHandler(dropdownData.city[0].value, cityFilterName)
  }, [])

  const selectHandlerCity = (value: string, name: string) => {
    setcurrentCity(value)
    setSelectedRegion(dropdownData.region[value][0])
    filterHandler(value, name)
  }

  useEffect(() => {
    setSelectedCity(() => currentValues.city)
    setSelectedRegion(() => currentValues.region)
    setcurrentCity(currentValues.city.value)
  }, [currentValues])

  return (
    <>
      <div className={[styles['filter-item'], styles['width-232']].join(' ')}>
        <span className={styles['filter-item__name']}>Город</span>
        <FiltersDropdownNew
          options={dropdownData.city}
          onSelect={selectHandlerCity}
          selected={selectedCity}
          name={cityFilterName}
        />
      </div>
      <div className={[styles['filter-item'], styles['width-142']].join(' ')}>
        <span className={styles['filter-item__name']}>Округ</span>
        <FiltersDropdownNew
          options={dropdownData.region[currentCity]}
          onSelect={filterHandler}
          selected={selectedRegion}
          name='region'
        />
      </div>
    </>
  )
}

export default InvestmentFilterDropdown
